module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": ""
    }
  }, [_c('main', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-container', {
    class: {
      'error': _vm.hasErrors
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Email",
      "required": "",
      "dark": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Password",
      "required": "",
      "dark": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    class: {
      'loading': _vm.isLoading
    },
    attrs: {
      "success": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_vm._v("\n                          Login\n                        ")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-xs-right"
  }, [_vm._v("Need an account? "), _c('router-link', {
    staticClass: "success--text",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  })) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a3cb15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 217
// module chunks = 1